import React, { memo, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';

import { Modal, Button } from '@gpstrackit/gtc-react-controls';

import { NotificationManager } from 'Components/Notifications';
// Material UI
import { Typography } from '@mui/material';

import {
    routesDeleteAllPoints,
    onUpdateRoute
} from 'Redux/actions';


import { reset as resetCreateEditRouteModalMain } from '../createEditRouteModalMain/redux/slice'
import { openModalDeleteRoutePoints, reset } from './redux/slice'


const ROUTE_KEY = "route";
const ROUTE_MULTIPE_KEY = "route_multiple";
const STOP_KEY = "stop";

const RoutesDeleteRoutePoints = () => {
  const dispatch = useDispatch();
  
  const { messages, locale } = useIntl();

  
  const openModal = useSelector(state => state.routesManagerDeleteRoutePoint?.open);
  const routeId = useSelector(state => state.routesManagerDeleteRoutePoint?.routeId);
  const loadingDeleteRoute = useSelector(state => state.routesManagedRedux.loading);
  const loadingManageMain = useSelector(state => state.routesManagedCreateEditRouteModalMainRedux?.loading);
  const loading = loadingDeleteRoute || loadingManageMain

  const route = useSelector(state => state.routesManagerEditPanelRouteRedux?.route);


  const handleClose = useCallback(() => {
      dispatch(openModalDeleteRoutePoints({ open: false, routeId: 0 }))
  });

  return (
    <Modal
      open={openModal || false}
      handleClose={handleClose}
      loading={loading}
      title={messages['fsmRoute_modal_delete_title']}
      position="right"
      size="small"
      closeButton={false}
      footer={
        <div>
          <Button 
          variant="secondary" 
          style={{ marginRight: 8 }} 
          onClick={() => { handleClose()}}
          >
            {messages['cancel']}
          </Button>
          <Button 
            variant="warning" 
            isDisabled={loading} 
            onClick={(e) => { 
              e.preventDefault();    
              //clear the points to the redux information at the route
              dispatch(onUpdateRoute({ route: { ...route, points: [] }, changesToSave: true }))
              dispatch(openModalDeleteRoutePoints({ open: false, routeId: 0 }))
            }}
            >
              {messages['delete']}
            </Button>
        </div>
      }
    >
      <div>
        <div style={{ padding: 24 }}>
          <Typography variant="subtitle2">
            {messages['fsmRoute_modal_delete_point']}
          </Typography>
        </div>
      </div>
    </Modal>
  );
}

export default memo(RoutesDeleteRoutePoints);